@use '@/styles/tokens' as *;
@use '@/styles/mixins' as *;

.card {
  display: flex;
  gap: var(--space-3);
  align-items: center;
  min-height: 74px;
  padding: var(--space-3);
  border: 1px solid $color-neutral-200;
  border-radius: 12px;
  background: $color-light-green-100;
}

.thumb {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 50px;
  overflow: hidden;
  border-radius: 8px;
  background: $color-neutral-100;
}

.thumbImg {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.text {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

.name {
  @include truncate;
  font-size: 15px;
  font-weight: 500;
  color: $color-neutral-800;
}

.subtitle {
  @include truncate;
  font-size: 13px;
  font-weight: 400;
  color: $color-neutral-600;
}
